import Vue from "vue";
import Vuex from "vuex";
import api from "../service/api";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    loginUser: null,
    // 判断公司是否认证，没认证不能用
    authorizedInfo: null,
    inQlw: false,
    curCompany: {
      isQlwVersion: null,
      name: ""
    },
    // 已打开的标签页列表
    visitedViews: [
      {
        title: '首页',
        path: '/',
        meta: {
          affix: true
        }
      }
    ],
    // 已缓存的组件
    cachedViews: []
  },
  getters: {
    visitedViews (state) {
      return state.visitedViews
    }
  },
  mutations: {
    setLoginUser(state, payload) {
      state.loginUser = payload;
    },
    setAuthorizedInfo(state, payload) {
      state.authorizedInfo = payload;
    },
    setInQlw(state) {
      state.inQlw = true;
    },
    setQlw(state, payload) {
      state.curCompany.isQlwVersion = payload;
    },
    setCurCompany(state, payload) {
      state.curCompany = payload;
    },
    // 追加加标签页
    PUSH_VISITED_VIEWS (state, value) {
      console.log(23333);
      let tag = state.visitedViews.find(item => item.path === value.path)
      if (tag) {
        tag.fullPath = value.fullPath
        console.log(state.visitedViews);
        return
      }
      state.visitedViews.push(value)
      const arr = value.path.split('/')
      const name = arr[arr.length - 1]
      state.cachedViews.push(name)
      console.log(state.cachedViews, '缓存的页签');
    },
    // 删除已访问标签页
    DEL_VISITED_VIEWS (state, value) {
      value.forEach(tag => {
        // 删除缓存数组
        const arr = tag.path.split('/')
        const name = arr[arr.length - 1]
        for (const index in state.cachedViews) {
          if (state.cachedViews[index] === name) {
            state.cachedViews.splice(index, 1);
            break;
          }
        }
        // 删除标签页数组
        for (const index in state.visitedViews) {
          if (state.visitedViews[index].path === tag.path) {
            return state.visitedViews.splice(index, 1)
          }
        }
      })
      console.log(state.cachedViews, '缓存的页签');
    },
    // 移动标签页
    MOVE_VISITED_VIEWS (state, value) {
      const { currentIndex, targetIndex } = value
      const rmTarget = state.visitedViews.splice(currentIndex, 1)
      state.visitedViews.splice(targetIndex, 0, rmTarget[0])
    }
  },
  actions: {
    async getSerialNumber() {
      let result = await api.get("/api/SerialNumber");
      return result.data;
    },
    async getLoginUser({ commit }) {
      let result = await api.get("/api/account/LoginUser");
      commit("setLoginUser", result.data);
    },
    // 获取认证信息
    async getAuthorizedInfo({ commit }) {
      let result = await api.get("/api/Enterprise/GetEnterpriseIsAuth?type=1");
      commit("setAuthorizedInfo", result.data);
    },
    async getCurCompany({ commit }) {
      let result = await api.get("/api/Enterprise/Simple");
      commit("setCurCompany", result.data);
      return result.data;
    },
    delVisitedViews ({ commit }, value) {
      commit('DEL_VISITED_VIEWS', value)
    },
    moveVisitedViews ({ commit }, value) {
      commit('MOVE_VISITED_VIEWS', value)
    }
  }
});
